exports.install = function (Vue, options) {
    //跳转页面
    Vue.prototype.open_page= function (url){
        this.$router.push({ path: url });
        window.scrollTo(0,0);
      };

};



// WEBPACK FOOTER //
// ./src/basejs.js